module.exports = __webpack_public_path__ + "static/media/imprensa@2x.67e5f0b7.png";